import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { TextField, Button } from "@mui/material";
import * as _ from 'lodash'

const Contact = () => {

  const [title, setTitle] = useState('')
  const [desc, setDesc] = useState('')

  return (
    <div className="page-content px-1 px-xl-5">
      <div className="ms-0 px-2 px-xl-3">
        <Row className="m-0 justify-content-between py-5">
          <Col xs={12} md={6} lg={5}>
            <div className="font-weight-500 font-size-16 mt-3">Сэдэв</div>
            <TextField 
              className="mt-3 mb-2 w-100" 
              label="Юуны талаар?" 
              variant="outlined"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <div className="font-weight-500 font-size-16 mt-3">Тайлбар</div>
            <TextField 
              className="mt-3 mb-2 w-100" 
              label="Дэлгэрэнгүй" 
              variant="outlined"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
            {
              !_.isEmpty(title) && !_.isEmpty(desc) && <Button 
                // onClick={() => setIsEdit(true)}
                className="bg-primary btn-bordered my-4 px-4" 
                variant="contained" 
                disableElevation
                endIcon={<i class='bx bx-right-arrow-alt'></i>}
              >
                Илгээх
              </Button>
            }
          </Col>
          <Col xs={12} md={6} lg={5}>
            <div className="bordered bg-light p-4 mt-4">
              <div className="font-size-16 font-weight-bold">Холбогдох мэдээлэл</div>
              <div className="d-flex font-size-14 align-items-center mt-4">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/contact.svg" height={12} />
                </div>
                7007 3001, 7007 3001
              </div>
              <div className="d-flex font-size-14 align-items-center mt-3">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/time.svg" height={12} />
                </div>
                Да - Ба 09:00 - 18:00 
              </div>
              <div className="d-flex font-size-14 align-items-center mt-3">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/mail.svg" height={10} />
                </div>
                info@shunkhlai@gmail.com
              </div>
              <div className="d-flex font-size-14 align-items-center mt-3">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/mail.svg" height={10} />
                </div>
                <div>
                  4th floor, Capital house, Chinggis avenue, 976 Ulaanbaatar, Mongolia
                </div>
              </div>
            </div>
            <div className="bordered bg-light p-4 mt-3">
              <div className="font-size-16 font-weight-bold">Цахим хаяг</div>
              <div className="d-flex font-size-14 align-items-center mt-4">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/web.svg" height={12} />
                </div>
                Shunkhlai.mn
              </div>
              <div className="d-flex font-size-14 align-items-center mt-3">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/fb.svg" height={12} />
                </div>
                Shunkhlai LLC
              </div>
              <div className="d-flex font-size-14 align-items-center mt-3">
                <div className="icon-container ms-3">
                  <img alt="office" src="/images/instagram.svg" height={14} />
                </div>
                Shunkhlai LLC
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Contact;
